/**
 * Hero dashboard subtle mouse parallax (desktop only).
 *
 * Uses lerp easing for smooth follow. RAF loop only runs while easing —
 * stops once target is reached, avoiding wasted frames.
 */
export function initDashboardParallax() {
  const dash = document.querySelector('.hero__visual .dashboard');
  if (!dash) return;
  if (!window.matchMedia('(hover: hover)').matches) return;

  let mx = 0, my = 0, tmx = 0, tmy = 0, raf = 0;

  document.addEventListener(
    'mousemove',
    (e) => {
      tmx = (e.clientX / window.innerWidth - 0.5) * 10;
      tmy = (e.clientY / window.innerHeight - 0.5) * 8;
      if (!raf) raf = requestAnimationFrame(tick);
    },
    { passive: true }
  );

  document.addEventListener('mouseleave', () => {
    tmx = 0;
    tmy = 0;
    if (!raf) raf = requestAnimationFrame(tick);
  });

  function tick() {
    mx += (tmx - mx) * 0.08;
    my += (tmy - my) * 0.08;
    dash.style.transform = `translate3d(${mx.toFixed(2)}px, ${my.toFixed(2)}px, 0)`;

    if (Math.abs(tmx - mx) > 0.05 || Math.abs(tmy - my) > 0.05) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = 0;
    }
  }
}
